<div class="slabs-wrapper" [ngClass]="config?.slab_theme">
  <div class="slabs">
    <button class="btn-style" *ngFor="let item of config?.slabs" (click)="setFrequency(item)" [ngClass]="{'selected-slab': slabsForm?.get('frequency')?.value===item}" mat-button>
      <span class="popular" *ngIf="config?.recommended_slab === item && config?.show_popular_slab && slabsForm?.get('frequency')?.value!==item && !config?.slab_theme?.match('v5')">MOST POPULAR</span>
      <span class="popular" *ngIf="config?.recommended_slab === item && config?.show_popular_slab && config?.slab_theme?.match('v5')"> <i class="material-icons">star</i> Popular</span>
      <div class="slabs-wrapper">
        <div class="selected-tick"><i class="material-icons">done</i></div>
        <span *ngIf="config?.pre_label" class="slab-label">{{config?.pre_label}}</span>
        <span class="slab-frequency">{{item}} {{config?.type==='days' && !config?.hide_item_text ? 'Days' : ''}}</span>
        <span *ngIf="config?.post_label" class="slab-label">{{config?.post_label}}</span>
      </div>
    </button>
  </div>
  <form *ngIf="!config?.hide_manual_input" [formGroup]="slabsForm">
    <button class="other-input-btn btn-style" (click)="showOtherInput()" mat-button>
      {{show_input_label ? config?.manual_input_label : ''}}
      <div class="other-input" #otherInput>
        <input [formControl]="slabsForm?.get('frequency')" (input)="setFrequency($event.target.value)" type="number" [min]="config?.min" [max]="config?.max" #manual_input>
      </div>
    </button>
    <small class="error-message" *ngIf="slabsForm?.get('frequency')?.invalid && slabsForm?.get('frequency')?.touched">
      {{config?.min && config?.max ? 'Please enter a value between ' + config?.min + ' and ' + config?.max : ''}}
      {{config?.min && !config?.max ? 'Please enter a value greater than or equal to ' + config?.min : ''}}
      {{!config?.min && config?.max ? 'Please enter a value less than or equal to ' + config?.max : ''}}
    </small>
  </form>
</div>